import React, { Component } from 'react';
import { array, arrayOf, bool, func, number, object, oneOfType, shape, string } from 'prop-types';
import Cell from 'ps-components/Table/Cell/Cell';
import CheckboxInput from 'ps-components/Input/CheckboxInput';
import Row from 'ps-components/Table/Row/Row';
import TruncatedString from 'ps-components/TruncatedString/TruncatedString';
import SurveyJobTitle from '../../GlobalJobMatching/SurveyJobMatches/SurveyJobTitle/SurveyJobTitle';

import './SurveyJobRow.scss';

const OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
class SurveyJobRow extends Component {
  static propTypes = {
    selectedJobConnection: array,
    showJobDescriptions: bool,
    surveyJob: shape({
      code: string,
      description: string,
      id: string,
      survey: shape({
        code: string,
        id: oneOfType([string, number]),
        name: string
      }),
      title: string
    }),
    updateTempMatches: func,
    tempMatchSelections: arrayOf(object)
  };

  static defaultProps = {
    showJobDescriptions: true
  };

  constructor(props) {
    super(props);

    this.state = { ids: [] };
  }

  componentDidMount() {
    this.setState({ ids: this._getIds() });
  }

  componentDidUpdate(prevProps, prevState) {
    const { selectedJobConnection, tempMatchSelections } = this.props;

    if (
      selectedJobConnection !== prevProps.selectedJobConnection ||
      (tempMatchSelections && tempMatchSelections.length !== prevProps.tempMatchSelections.length)
    ) {
      this.setState({ ids: this._getIds() });
    }
  }

  getSurveyJobTitleDisplay = () => {
    const { surveyJob, showJobDescriptions } = this.props;

    return (
      <SurveyJobTitle
        description={surveyJob.description}
        title={surveyJob.title}
        showJobDescription={showJobDescriptions}
      />
    );
  };

  _getIds() {
    const { selectedJobConnection, tempMatchSelections } = this.props;

    return tempMatchSelections
      ? tempMatchSelections.map(match => match.surveyJobId)
      : selectedJobConnection.map(connection => connection.surveyJob.id);
  }

  addOrRemoveSurveyJob = () => {
    const { createJobMatch, deleteJobMatch, selectedJob, surveyJob, updateTempMatches } = this.props;
    const { ids } = this.state;

    const jobToDelete = selectedJob.jobMatches
      ? selectedJob.jobMatches.find(job => job.surveyJob.id === surveyJob.id)
      : null;
    const hasSurveyJob = surveyJob.survey && surveyJob.survey.code;
    ids.includes(surveyJob.id)
      ? deleteJobMatch([jobToDelete.id], selectedJob.id)
      : createJobMatch(selectedJob.id, surveyJob.code, hasSurveyJob ? surveyJob.survey.code : '');
  };

  updateTempMatches = () => {
    const { updateTempMatches, surveyJob } = this.props;
    const hasSurveyJob = surveyJob.survey && surveyJob.survey.id;
    const surveyCode = hasSurveyJob ? surveyJob.survey.code : '';
    updateTempMatches(surveyJob.code, surveyCode, surveyJob.id);
  };

  render() {
    const { surveyJob, showJobDescriptions, updateTempMatches } = this.props;
    const { ids } = this.state;

    return (
      <Row className="survey__job-row">
        <Cell className="data__cell-checkbox">
          <CheckboxInput
            className="data__cell-checkbox-input"
            checked={ids.includes(surveyJob.id)}
            onClick={updateTempMatches ? this.updateTempMatches : this.addOrRemoveSurveyJob}
            disabled={surveyJob.isMeritMatch}
          />
        </Cell>
        <Cell className="data__cell-data pxl-text-xsmall">
          {surveyJob.isMeritMatch && <div className="data__cell-datum merit-match-indicator">Market Pricing Match</div>}
          <div className="data__cell-datum pxl-text-muted">{surveyJob.code}</div>
          <div className="data__cell-datum datum__bold pxl-text-small">{this.getSurveyJobTitleDisplay()}</div>
          {showJobDescriptions && <TruncatedString maxChar={150}>{surveyJob.description}</TruncatedString>}
        </Cell>
        <Cell className="data__cell-data pxl-text-xsmall">
          <div className="data__cell-datum pxl-text-muted">
            {surveyJob.survey && surveyJob.survey.code ? surveyJob.survey.code : 'N/A'}
          </div>
          <div className="data__cell-datum">
            {surveyJob.survey && surveyJob.survey.name ? surveyJob.survey.name : 'N/A'}
          </div>
        </Cell>
      </Row>
    );
  }
}

export default SurveyJobRow;
